import { Grid } from '@mui/material';

import { formatNumber } from 'common/utils/utilFunctions';

import { ListOfMetricsValue } from 'features/HomePage/api/type-def';

import homePageStyles from './MetricsCard.module.scss';

const MetricsCards = (props: ListOfMetricsValue) => {
	const { label, count, imgLink } = props;
	return (
		<Grid className={homePageStyles['overview-metrics-container']}>
			<Grid container className={homePageStyles['metrics-card']}>
				<Grid
					item
					xs={12}
					md={12}
					lg={12}
					xl={12}
					className={homePageStyles['metrics-card-label']}
				>
					{label}
				</Grid>
				<Grid item className={homePageStyles['metrics-card-data']}>
					<div className={homePageStyles['metrics-card-data-priority']}>
						{imgLink}
					</div>
					<div className={homePageStyles['metrics-card-data-count']}>
						{formatNumber(count)}
					</div>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default MetricsCards;
